import React from 'react'

import CsvDownloadLink from 'components/CsvDownloadLink'
import FileUpload from 'components/FileUpload/FileUpload'
import { domains } from '../../../lib/config'
import PropTypes from 'prop-types'
import Loading from 'components/Loading/Loading'
import {
  BROWSE,
  DOWNLOAD_RESULTS_LINK_LABEL,
  FIELD_DESCRIPTION_HS_IMPLEMENTATION_LEVEL,
  FIELD_DESCRIPTION_HS_IMPLEMENTATION_TYPE,
  FIELD_DESCRIPTION_HS_IS_LAUNCHED,
  FIELD_DESCRIPTION_HS_STUDENT_ACTIVITIES,
  FIELD_DESCRIPTION_MS_BULLYING_OPT,
  FIELD_DESCRIPTION_SITE_ID,
  SITE_PREFERENCES_TOOL_TITLE,
  TOOL_DESCRIPTION,
  UPLOAD,
} from './constants'
import { csvTemplateHeaders } from './data.js'
import {
  ExampleImage,
  Instructions,
  Required,
  ResultsSection,
  StyledAutoTable,
  TemplateLinkWrapper,
  UploadButton,
  UploadSection,
} from './styles'

SitePreferences.propTypes = {
  error: PropTypes.string,
  file: PropTypes.object,
  fileName: PropTypes.string.isRequired,
  handleUpload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFileChange: PropTypes.func.isRequired,
  formattedUploadResults: PropTypes.array,
}

const headers = [
  { label: 'Site Id', key: 'siteId' },
  { label: 'siteName', key: 'siteName' },
  { label: 'error', key: 'error' },
]

const columns = [
  {
    title: 'Site ID',
    fieldValue: row => row.siteId,
    sortValue: 'siteId',
  },
  {
    title: 'Site Name',
    fieldValue: row => row.siteName,
    sortValue: 'siteName',
  },
  {
    title: 'Error',
    fieldValue: row => row.error,
    sortValue: 'error',
  },
]

export default function SitePreferences(props) {
  const { file, fileName, isLoading, onFileChange, formattedUploadResults } =
    props || {}

  return (
    <React.Fragment>
      <Loading isLoading={isLoading} message="Processing file...." />
      <h2>{SITE_PREFERENCES_TOOL_TITLE}</h2>
      <hr />
      <h3>Tool Description</h3>
      <p>{TOOL_DESCRIPTION}</p>
      <TemplateLinkWrapper>
        <CsvDownloadLink
          filename={'site_preferences_template.csv'}
          data={[{}]}
          headers={csvTemplateHeaders}
          autoClick={false}
        >
          <h5>Download Site Preferences Template</h5>
        </CsvDownloadLink>
      </TemplateLinkWrapper>
      <i>
        Upload your <code>.xlsx</code> or <code>.csv</code> in the format below.
      </i>
      <FileUpload
        disabled={isLoading}
        fileName={fileName}
        key={fileName}
        onFileChange={onFileChange}
      >
        {BROWSE}
      </FileUpload>
      <UploadSection>
        <div>
          <UploadButton
            disabled={!file || isLoading}
            onClick={() => props.handleUpload({ ...props })}
          >
            {UPLOAD}
          </UploadButton>
        </div>
      </UploadSection>
      <ResultsSection>
        {formattedUploadResults && (
          <React.Fragment>
            <CsvDownloadLink
              filename={
                new Date().toISOString() + '_site_preferences_results.csv'
              }
              data={formattedUploadResults}
              headers={headers}
              autoClick={false}
            >
              {DOWNLOAD_RESULTS_LINK_LABEL}
            </CsvDownloadLink>
            <StyledAutoTable
              borderless
              columns={columns}
              headThemeLight
              rows={formattedUploadResults}
            />
          </React.Fragment>
        )}
      </ResultsSection>
      <h4>Fields Description</h4>
      <span>** Unset fields will not be changed or updated</span>
      <ul>
        <li>
          <b>SiteId:</b> {FIELD_DESCRIPTION_SITE_ID}{' '}
          <Required>Required</Required>
        </li>

        <li>
          <b>highSchool_ImplementationLevel:</b>{' '}
          {FIELD_DESCRIPTION_HS_IMPLEMENTATION_LEVEL}
        </li>
        <li>
          <b>highSchool_ImplementationType:</b>{' '}
          {FIELD_DESCRIPTION_HS_IMPLEMENTATION_TYPE}
        </li>
        <li>
          <b>highSchool_IsLaunched:</b> {FIELD_DESCRIPTION_HS_IS_LAUNCHED}
        </li>
        <li>
          <b>highSchool_StudentActivities:</b>{' '}
          {FIELD_DESCRIPTION_HS_STUDENT_ACTIVITIES}
        </li>

        <li>
          <b>mspDigital_BullyingHarassmentUnitEnabled: </b>{' '}
          {FIELD_DESCRIPTION_MS_BULLYING_OPT}
        </li>
      </ul>
      <Instructions>
        All uploaded spreadsheets should be formatted like this:
      </Instructions>
      <ExampleImage
        src={`${domains.CDN_DOMAIN}/assets/img/sites_preferences_preview.png`}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/sitePreferences/SitePreferences.js